// import round from "lodash/round";
import range from "lodash/range";
import shuffle from "lodash/shuffle";
import throttle from "lodash/throttle";
import floor from "lodash/floor";
import isEqual from "lodash/isEqual";
import replace from "lodash/replace";
import uniq from "lodash/uniq";
import min from "lodash/min";
import findIndex from "lodash/findIndex";

export {
  range,
  shuffle,
  throttle,
  floor,
  isEqual,
  replace,
  uniq,
  min,
  findIndex
};



// WEBPACK FOOTER //
// ./src/lib/lodash.js